import { Record } from 'immutable';

export default class ListRecord extends Record({
    id: null,
    label: '',
    type: null
  }) {
    
  }
